module.exports = __webpack_public_path__ + "static/media/AvailableXp.3e0e1611.svg";